import React, { Component } from 'react';
import Main from './components/main/component';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){
        // this.initializeReactGA();
        // this.initializeReactGA4();
        // this.initializeReactPixel();
    }

    initializeReactGA() {
        if(this.platformLive()){
            ReactGA.initialize('UA-133715853-1');
        }
    }

    initializeReactGA4() {
        if(this.platformLive()){
            ReactGA4.initialize('G-WC2VNS108X');
        }
    }

    initializeReactPixel() {
        if(this.platformLive()){
            ReactPixel.init('120964126779408');
        }
    }

    platformLive() {
        try {
            return window.location.hostname.indexOf('dev') === -1;
        } catch (e) {
            return false
        }
    }

    render() {
        return (
            <Main />
        )
    }

}

export default App



// WEBPACK FOOTER //
// ./src/App.js